import { memo } from 'react';
import { MenuItemProps } from '../../../../_N60Footer/components/MenuArea';
import styles from './menu-item.module.css';
import { weakKey } from '~/shared/utils/jsx/utils/weak-key';
import { CMSLink } from '~/shared/components';
import clsx from 'clsx';

export const MenuItem = memo(({ menuItem }: MenuItemProps) => {
    const { children } = menuItem;
    const validChildren = children ? children.filter((node) => Boolean(node.link)) : [];

    return (
        <ul className={styles.root}>
            {validChildren.map(
                ({ link }) =>
                    link?.url && (
                        <li key={weakKey(link)}>
                            <CMSLink
                                href={link.url}
                                className={clsx(styles.link, 'hover-effect-underline-center')}
                                prefetch={false}
                                target={link.target}
                                title={link.title}
                            >
                                {link.text || link.title}
                            </CMSLink>
                        </li>
                    )
            )}
        </ul>
    );
});
